import AuthService from '../services/AuthService'

import store from '@/store';

/**
 * Filter for routes requiring an authenticated user
 * @param {*} to 
 * @param {*} from 
 * @param {*} next 
 */
export default function requireAuth(to, from, next) {
    if (!AuthService.isConnected) {
        
        // check in the store if the user is currently logging out
        var isLogginggOut = store.getters.getIsLoggingOut;
        // If not, we can display a snackbar to alert about the session timeout
        if(!isLogginggOut) {
            store.dispatch('setSnackbar', {
                status: 'session_timeout',
              });
        }  
              
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });

        return;
    }

    var requiredProviders = to.meta.requiredProviders;

    if (requiredProviders && !AuthService.isBoundToProvider(requiredProviders)) {
        next({
            path: '/'
        });

        return;
    };

    next();
}